import React from 'react'
import { useNavigate } from 'react-router-dom'

// helpers
import { getPreviousStep } from 'lib/helpers/registration/navigation'

const withEventHandlers = WrappedComponent => {
  return props => {
    const {
      account, // via withQuery
      onlineOnly // via withQuery
    } = props

    const navigate = useNavigate()

    const handleClickStep = step => e => {
      // no navigation if not logged in
      if (!account) {
        return
      }

      // no navigation once account is registered
      if (account.registrationStatus && account.registrationStatus.registered) {
        return
      }

      // if this is the first step, always allow navigation
      const previousStep = getPreviousStep({ step, onlineOnly })
      if (!previousStep) {
        navigate(step.path)
        return
      }

      // otherwise, allow navigation if the previous step is completed
      const completed = previousStep.isCompleted(account)
      if (completed) {
        navigate(step.path)
      }
    }

    return <WrappedComponent onClickStep={handleClickStep} {...props} />
  }
}

export default withEventHandlers
